






import { Component, Vue, Provide } from 'vue-property-decorator';

@Component({ name: 'accordion' })
export default class AccordionComponent extends Vue {
  public selected = '';

  @Provide()
  public getSelected() { return this.selected; }

  @Provide()
  public setSelected(key: string) { return this.selected = this.selected === key ? '' : key; }
}
